import { Component } from '@theme/component';
import { SubscriptionToggleUpdateEvent } from '@theme/events';

/**
 * @class SubscriptionToggleComponent
 * @extends {Component}
 * @typedef {Object} Refs
 * @property {Element} toggleSwitch - The toggle switch element.
 * @description A component that toggles the subscription for a given event.
 */
class SubscriptionToggleComponent extends Component {
  /**
   * Toggles the subscription for the given event.
   * @param {Event} event - The event.
   */
  toggleSubscription(event) {
    if (event.target instanceof Element) {
      event.target.parentElement?.classList.toggle('active');
      this.#onSubscriptionToggleUpdate(event);
    }
  }

  /**
   * Handles the subscription toggle update event.
   * @param {Event} event - The event.
   */
  #onSubscriptionToggleUpdate(event) {
    const toggleSwitch = this;
    if (toggleSwitch instanceof Element) {
      let lineElement = toggleSwitch?.querySelector('input');
      let lineKey = lineElement?.getAttribute('data-toggle-line-item-key');
      let sellingPlanId = lineElement?.checked ? lineElement?.value : null;
      if (lineKey) {
        const lineIndex = Number(lineKey);
        const itemQuantity = Number(lineElement?.getAttribute('data-item-quantity')) || 1;
        document?.dispatchEvent(new SubscriptionToggleUpdateEvent(lineIndex, sellingPlanId ? Number(sellingPlanId) : null, itemQuantity));
      }
    }
  }
}

customElements.define('subscription-toggle-button', SubscriptionToggleComponent);